import React from 'react';

class BlogDocumentation extends React.Component {
    render() {
        return(
            <div className="tab blog-3">
            {/* DOCUMENTATION */}
                <h2>HTML Documentation - The Basics</h2>

                <div className="input-row">
                    <p>Text to HTML conversion – this is a simple tool to type your words in on the left and output in HTML on the right. You can also edit the HTML on the right to see how it changes the text on the left and practice or learn more about HTML <a href="https://wordtohtml.net/site/index">https://wordtohtml.net/site/index</a></p>
                </div>

                <div className="input-row">
                    <label>Headings: h1, h2, h3, h4, h5, h6</label>
                    <p>&lt;h1&gt;<strong>your title here</strong>&lt;/h1&gt;</p>
                </div>
                <div className="input-row">
                    <label>Paragraph</label>
                    <p>&lt;p&gt;<strong>your text here</strong>&lt;/p&gt;</p>
                </div>
                <div className="input-row">
                    <label>Italic / Bold</label>
                    <div>
                        <p>&lt;em&gt;<strong><em>italic text here</em></strong>&lt;/em&gt;</p>
                        <p>&lt;strong&gt;<strong>bold text here</strong>&lt;/strong&gt;</p>
                    </div>
                </div>
                <div className="input-row">
                    <label>Link in same website</label>
                    <p>&lt;a href='<strong>/whatever/page-name</strong>'&gt;<strong>link or &lt;img /&gt;</strong>&lt;/a&gt;</p>
                </div>
                <div className="input-row">
                    <label>Link on diff website</label>
                    <p>&lt;a href='<strong>https://whatever.com</strong>' target='_blank'&gt;<strong>link or &lt;img /&gt;</strong>&lt;/a&gt;</p>
                </div>
                <div className="input-row">
                    <label>Image</label>
                    <p>&lt;img src='<strong>https://whatever.com/image.jpg</strong>' /&gt;</p>
                </div>
                <div className="input-row">
                    <label>Image With Caption</label>
                    <div>
                        <p>&lt;figure&gt;</p>
                            <p>&lt;img src='<strong>https://whatever.com/image.jpg</strong>' /&gt;</p>
                            <p>&lt;figcaption&gt;<strong>a caption!</strong>&lt;/figcaption&gt;</p>
                        <p>&lt;/figure&gt;</p>
                    </div>
                </div>
                <div className="input-row">
                    <label>Bulleted List</label>
                    <div>
                        <p>&lt;ul&gt;</p>
                        <p>&lt;li&gt;<strong>bullet item 1</strong>&lt;/li&gt;</p>
                        <p>&lt;li&gt;<strong>bullet item 2</strong>&lt;/li&gt;</p>
                        <p>&lt;/ul&gt;</p>
                    </div>
                </div>
                <div className="input-row">
                    <label>Numbered List</label>
                    <div>
                        <p>&lt;ol&gt;</p>
                        <p>&lt;li&gt;<strong>bullet item 1</strong>&lt;/li&gt;</p>
                        <p>&lt;li&gt;<strong>bullet item 2</strong>&lt;/li&gt;</p>
                        <p>&lt;/ol&gt;</p>
                    </div>
                </div>
                <div className="input-row">
                    <label>Basic Examples....</label>
                </div>
                <div className="input-row">
                    <div className="article-preview">
                        <p>&lt;p&gt;This is an &lt;em&gt;<strong><em>example</em></strong>&lt;/em&gt; paragraph for &lt;strong&gt;<strong>training</strong>&lt;/strong&gt; purposes only!&lt;/p&gt; </p>
                        <p>This is an <em>example</em> paragraph for <strong>training</strong> purposes only!</p>
                        <br />
                        <p>&lt;p&gt;This is another paragraph with a &lt;a href='<strong>https://google.com</strong>' target='_blank'&gt;<strong>link</strong>&lt;/a&gt; to google.&lt;/p&gt;</p>
                        <p>This is another paragraph with a <a href="https://google.com" target="_blank" rel="noopener noreferrer">link</a> to google.</p>
                    </div>
                </div>
            </div>
        )
    }
}
export default BlogDocumentation;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogProfile/BlogDocumentation.js